import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdOutlineLogout } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Image } from "react-bootstrap";
import Dash3 from "../../assets/d-1.svg";
import Dash4 from "../../assets/d-2.svg";
import Savings from "../../assets/savings.svg";
import Dash5 from "../../assets/tc-1.svg";
import emailpic from "../../assets/email.svg";
import { Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import SideBar from "../SideBar/SideBar";
import TabsSection from "../Tabs/TabsSection";
import { BusinessListingPlus } from "./../API/BusinessListingAPI/BusinessListingPlus";
import Loader from "../../Components/Loader/Loader";
import { DeleteRowApi } from "./../API/BusinessListingAPI/DeleteRow";
import { UpdateStatusApi } from "./../API/BusinessListingAPI/UpdateStatus";
import Pagination from "../Pagination/Pagination";
import { saveAs } from "file-saver";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import swal from "sweetalert";
import Preview from "../../assets/preview.svg";
import NoDataText from "../NoDataText";
import SearchBarResults from "../Search/SearchBarResults";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "./../PrivacyTermsConditions/PrivacyTermsConditions";
import { EventsListingApi } from "../API/Events/EventsListApi";
import { UpdateEventListStatusApi } from "../API/Events/UpdateEventListStatus";
import { ExportEventsListingAPi } from "../API/Events/ExportEventsListing";
import editpic from "../../assets/edit.svg";
import deletepic from "../../assets/delete.svg";
import { format, parse, isValid } from "date-fns";
import { FroalaDefault } from "../../Utils/FroalaDefaultText";
import { FroalaEditorEvent } from "../FroalaEditor/FroalaEditor";
import { SendEventRequestApi } from "../API/Events/SendEventRequest";



const EventsListing = () => {
    let navigate = useNavigate();
    const cityId = localStorage.getItem("cityId");
    const [TemplateContent, setTemplateContent] = useState(FroalaDefault.text);

    const [loading, setLoading] = useState(false);
    const [TableRows, setTableRows] = useState([]);
    const [globalTableRows, setglobalTableRows] = useState([]);

    const [title, setTitle] = useState("");
    const [selctedRow, setselctedRow] = useState(null);
    const [expandedRows, setExpandedRows] = useState("");
    const [expandedRowsData, setExpandedRowsData] = useState({});
    const [listingNo, setlistingNo] = useState(5);
    //
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [isCheck, setIsCheck] = useState([]);
    const [ShowTable, setShowTable] = useState(false);
    const [Nodata, setNodata] = useState(false);



    // search
    const [searchValue, setsearchValue] = useState("");
    // pagination
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(0);
    const [limit, setLimit] = useState(0);
    // sort
    const [flag, setFlag] = useState({
        event_name: 0,
        organization_name: 0,
        event_location: 0,
        event_start_date: 0,
        event_end_date: 0,
        event_status: 0,
    });

    // popup-modal
    const [modalShow, setModalShow] = React.useState(false);

    // request-popup
    const [sortColumnName, setSortColumnName] = useState("created_at");
    const [sortValue, setSortValue] = useState(0)
    const [requestHandler, setRequestHandler] = useState({})
    const [VistPageLink, setVistPageLink] = useState("");
    const [newEventTotalCount, setNewEventTotalCount] = useState(0)

    const path = window.location.href;
    const endPath = path.split("/");

    const handleEventListing = async () => {
        const data = {
            limit: 10,
            search_value: searchValue,
            column_name: sortColumnName,
            sort_type: sortValue,
            export: false,
            listing_for: listingNo,
            offset: pageNumber,
        };
        const eventsListingData = await EventsListingApi(data, () => {
            navigate("/");
        });
        setLoading(false);
        if (eventsListingData == false) {
            swal({
                // title: "Error!",
                title: NoDataText.InternalErr,
                icon: "error",
                buttons: "Ok",
                dangerMode: true,
            });
        } else {
            if (eventsListingData.status === 429) {
                setLoading(true);
                setShowTable(false);
                swal({
                    // title: "Error!",
                    title: eventsListingData.message,
                    icon: "error",
                    // buttons: "Ok",
                    dangerMode: true,
                });
            } else if (eventsListingData.message === "No Data Available") {
                setShowTable(true);
            } else {
                setVistPageLink(eventsListingData?.marketplace_event_url);
                setShowTable(false);
                setTableRows(eventsListingData?.data);
                setglobalTableRows(eventsListingData?.data);
                setTotalPageCount(eventsListingData?.total_count);
                setNewEventTotalCount(eventsListingData?.new_event_total_count);
                setLimit(eventsListingData?.limit);
            }
        }
    };


    useEffect(() => {
        handleEventListing();
    }, [sortValue, sortColumnName, pageNumber, listingNo])
    useEffect(() => {
        setLoading(true);
        const url = endPath[4]?.replace(/-/g, " ");
        const arr = url?.split(" ");
        for (var i = 0; i < arr.length; i++) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
        }
        const url_final = arr.join(" ");
        setTitle(url_final);

        if (endPath[4] === "all-events") {
            setlistingNo(5);
        }
        if (endPath[4] === "new-events") {
            setlistingNo(1);
        }
        if (endPath[4] === "in-review-events") {
            setlistingNo(2);
        }
        if (endPath[4] === "published-events") {
            setlistingNo(3);
        }
        if (endPath[4] === "declined-events") {
            setlistingNo(4);
        }
    }, [path, pageNumber, listingNo]);


    const handlePlusShow = async (bu_id) => {
        const data = {
            mms_city_id: parseInt(cityId),
            bu_id: bu_id,
        };
        const BusinessListingPlusData = await BusinessListingPlus(data, () => {
            navigate("/");
        });

        if (BusinessListingPlusData == false) {
            swal({
                // title: "Error!",
                title: NoDataText.InternalErr,
                icon: "error",
                buttons: "Ok",
                dangerMode: true,
            });
        } else {
            if (BusinessListingPlusData.status === 429) {
                swal({
                    // title: "Error!",
                    title: BusinessListingPlusData.message,
                    icon: "error",
                    buttons: "Ok",
                    dangerMode: true,
                });
                setLoading(true);
            } else if (BusinessListingPlusData.message == "No Data") {
                setNodata(true);
                setLoading(false);
            } else {
                setNodata(false);
                setExpandedRowsData(BusinessListingPlusData);
                setLoading(false);
            }
        }
    };


    function dateFromt(date) {
        // Parsing the event_start_date string ("Fri, 25 Jul 2025 00:00:00 GMT") to a Date object
        const parsedDate = parse(date, "EEE, dd MMM yyyy HH:mm:ss 'GMT'", new Date());

        // Check if the parsed date is valid and format it as 'yyyy-MM-dd'
        if (isValid(parsedDate)) {
            const formattedStartDate = format(parsedDate, "yyyy-MM-dd");
            return formattedStartDate; // Set the state with the formatted date
        }
    }



    // update status
    const handleChangeDropDown = (e, key) => {
        setLoading(true);
        const data = {
            mms_city_id: parseInt(cityId),
            option: "status",
            actionIds: [TableRows[key].event_id],
            status_id: parseInt(e.target.value),
        };
        swal({
            title: `Are you sure you want to update status of ${TableRows[key].event_name}?`,
            icon: "warning",
            buttons: true,
            dangerMode: false,
        }).then((willDelete) => {
            if (willDelete) {
                setLoading(true);
                UpdateEventListStatusApi(data, () => {
                    navigate("/");
                });
                setTimeout(() => {
                    setLoading(false);
                    swal({
                        title: `${TableRows[key].event_name} status has been updated successfully!`,
                        icon: "success",
                        buttons: "Ok",
                    });
                    handleEventListing();
                }, 1000);
            } else {
                swal({
                    text: "Please wait...",
                    icon: "error",
                    buttons: "Ok",
                });
                handleEventListing();
                setTimeout(() => {
                    window.location.reload(false);
                }, 1000);
            }
        });
        setLoading(false);
    };

    const handleChangeDropDownTop = (e) => {
        setLoading(true);
        const data = {
            mms_city_id: parseInt(cityId),
            option: "status",
            actionIds: isCheck,
            status_id: parseInt(e.target.value),
        };
        swal({
            title: `Are you sure you want to update status for selected business?`,
            icon: "warning",
            buttons: true,
            dangerMode: false,
        }).then((willDelete) => {
            if (willDelete) {
                setLoading(true);
                UpdateStatusApi(data, () => {
                    navigate("/");
                });
                setTimeout(() => {
                    setLoading(false);
                    swal({
                        title: `Selected business status has been updated successfully!`,
                        icon: "success",
                        buttons: "Ok",
                    }).then((ok) => {
                        if (ok) {
                            setTimeout(() => {
                                window.location.reload(false);
                            }, 100);
                        }
                    });
                }, 1000);
            } else {
                swal({
                    text: "Please wait...",
                    icon: "error",
                    buttons: "Ok",
                });
                setTimeout(() => {
                    window.location.reload(false);
                }, 1000);
            }
        });
        setLoading(false);
    };

    // Delete
    const handleDelete = () => {
        setLoading(true);
        console.log("isCheck", isCheck)
        const data = {
            option: "delete",
            actionIds: isCheck,
        };
        swal({
            title: `Are you sure you want to delete selected Business?`,
            text: "Once deleted, you will not be able to recover!",
            icon: "error",
            buttons: true,
            dangerMode: false,
        }).then((willDelete) => {
            if (willDelete) {
                DeleteRowApi(data, () => {
                    navigate("/");
                });
                swal({
                    // title: "Success!",
                    title: `Selected Business has been deleted successfully!`,
                    icon: "success",
                    buttons: false,
                });
                setTimeout(() => {
                    window.location.reload(false);
                }, 1000);
            } else {
                swal({
                    text: "Please wait...",
                    icon: "error",
                    buttons: "Ok",
                });

                setTimeout(() => {
                    window.location.reload(false);
                }, 1000);
            }
        });
        setLoading(false);
    };

    const handleDeleteEach = async (e, key) => {
        setLoading(true);

        const data = {
            option: "delete",
            actionIds: [TableRows[key].event_id],
        };
        swal({
            title: `Are you sure you want to delete ${TableRows[key].event_name}?`,
            text: "Once deleted, you will not be able to recover!",
            icon: "error",
            buttons: true,
            dangerMode: false,
        }).then((willDelete) => {
            if (willDelete) {
                UpdateEventListStatusApi(data, () => {
                    navigate("/");
                });
                handleEventListing();
                swal({
                    // title: "Success!",
                    title: `${TableRows[key].event_name} has been deleted successfully!`,
                    icon: "success",
                    buttons: false,
                });
                // setTimeout(() => {
                //     window.location.reload(false);
                // }, 1000);
            } else {
                swal({
                    text: "Please wait...",
                    icon: "error",
                    buttons: "Ok",
                });

                setTimeout(() => {
                    window.location.reload(false);
                }, 1000);
            }
        });
        setLoading(false);
    };



    const handleRequestPopup = async (e, key) => {
        setNodata(false);
        setLoading(false);
        setModalShow(true);
        setRequestHandler(TableRows[key]);

    };



    const SendRequest = async (e) => {
        e.preventDefault();

        const data = {
            event_id: parseInt(requestHandler?.event_id),
            event_name: requestHandler?.event_name,
            email_subject: requestHandler?.email_subject,
            email_address: requestHandler?.organizer_email,
            email_content: TemplateContent
        };
        if (
            data?.email_content
        ) {
            const response = await SendEventRequestApi(data, () => {
                navigate("/");
            });
            if (response == false) {
                swal({
                    // title: "Error!",
                    title: NoDataText.InternalErr,
                    icon: "error",
                    buttons: "Ok",
                    dangerMode: true,
                });
            } else {
                if (response.status === 429) {
                    setLoading(true);
                    swal({
                        // title: "Error!",
                        title: `${response.message}!`,
                        icon: "error",
                        buttons: "Ok",
                    });
                } else if (response.success == false) {
                    setLoading(false);
                    setModalShow(false);
                    swal({
                        // title: "Error!",
                        title: `${response.message}!`,
                        icon: "error",
                        buttons: "Ok",
                    });
                } else {
                    setModalShow(false);
                    setLoading(false);
                    swal({
                        title: `${response.message}!`,
                        icon: "success",
                        buttons: "Ok",
                    });
                    setRequestHandler({});
                    setTemplateContent(FroalaDefault.text)
                }
            }
        }
    };

    // search
    const handleSearchInput = (e) => {
        setsearchValue(e.target.value);
        if (e.target.value.length == 0) {
            setShowTable(false);
            setTableRows(globalTableRows);
        }
    };

    const handleKeypress = (e) => {
        if (e.code === "Enter") {
            handleEventListing();
        }
    };


    // export
    const handleExport = async () => {
        setLoading(true);
        const data = {
            // limit: 10,
            // search_value: searchValue,
            // column_name: sortColumnName,
            // sort_type: sortValue,
            export: true,
            listing_for: listingNo,
            offset: pageNumber,
        };
        const ExportData = await ExportEventsListingAPi(data, () => {
            navigate("/");
        });

        let blob = new Blob([ExportData], {
            type: "application/vnd.ms-excel",
        });
        saveAs(blob, `${title}.xlsx`);
        setLoading(false);
    };

    // function to sort-button
    const HandleSortCol = (value) => {
        setSortColumnName(value)
        // business_name: 0,
        if (value == "event_name") {
            if (flag.event_name === 0) {
                setSortValue(1)
                setFlag((item) => {
                    return { ...item, event_name: 1 };
                });
            } else if (flag.event_name === 1) {
                setSortValue(2)
                setFlag((item) => {
                    return { ...item, event_name: 2 };
                });
            } else {
                setSortValue(0)
                setFlag((item) => {
                    return { ...item, event_name: 0 };
                });
            }
        }
        // category: 0,
        if (value == "organization_name") {
            if (flag.organization_name === 0) {
                setSortValue(1)
                setFlag((item) => {
                    return { ...item, organization_name: 1 };
                });
            } else if (flag.organization_name === 1) {
                setSortValue(2)
                setFlag((item) => {
                    return { ...item, organization_name: 2 };
                });
            } else {
                setSortValue(0)
                setFlag((item) => {
                    return { ...item, organization_name: 0 };
                });
            }
        }
        // applied_date:0
        if (value == "event_start_date") {
            if (flag.event_start_date === 0) {
                setSortValue(1)
                setFlag((item) => {
                    return { ...item, event_start_date: 1 };
                });
            } else if (flag.event_start_date === 1) {
                setSortValue(2)
                setFlag((item) => {
                    return { ...item, event_start_date: 2 };
                });
            } else {
                setSortValue(0)
                setFlag((item) => {
                    return { ...item, event_start_date: 0 };
                });
            }
        }
        // city: 0,
        if (value == "event_end_date") {
            if (flag.event_end_date === 0) {
                setSortValue(1)
                setFlag((item) => {
                    return { ...item, event_end_date: 1 };
                });
            } else if (flag.event_end_date === 1) {
                setSortValue(2)
                setFlag((item) => {
                    return { ...item, event_end_date: 2 };
                });
            } else {
                setSortValue(0)
                setFlag((item) => {
                    return { ...item, event_end_date: 0 };
                });
            }
        }

        // location: 0,
        if (value == "event_location") {
            if (flag.event_location === 0) {
                setSortValue(1)
                setFlag((item) => {
                    return { ...item, event_location: 1 };
                });
            } else if (flag.event_location === 1) {
                setSortValue(2)
                setFlag((item) => {
                    return { ...item, event_location: 2 };
                });
            } else {
                setSortValue(0)
                setFlag((item) => {
                    return { ...item, event_location: 0 };
                });
            }

        }

        // status: 0,
        if (value == "event_status") {
            if (flag.event_status === 0) {
                setSortValue(1)
                setFlag((item) => {
                    return { ...item, event_status: 1 };
                });
            } else if (flag.event_status === 1) {
                setSortValue(2)
                setFlag((item) => {
                    return { ...item, event_status: 2 };
                });
            } else {
                setSortValue(0)
                setFlag((item) => {
                    return { ...item, event_status: 0 };
                });
            }

        }
    };

    function formatDate(date) {
        // Parsing the event_start_date string ("Fri, 25 Jul 2025 00:00:00 GMT") to a Date object
        const parsedDate = parse(date, "EEE, dd MMM yyyy HH:mm:ss 'GMT'", new Date());

        // Check if the parsed date is valid and format it as 'yyyy-MM-dd'
        if (isValid(parsedDate)) {
            const formattedStartDate = format(parsedDate, "dd MMM yyyy");
            return formattedStartDate; // Set the state with the formatted date
        }
    }




    return (
        <>
            {loading ? <Loader /> : ""}
            <div className="gray-bg">
                <div className="navbar-section p-0">
                    <SideBar />
                </div>

                <div className="main-content pt-5 pr-3 pb-4">
                    <BackButton />

                    <p className="page-maintitle">Events Listings</p>

                    <div className="acc-dashboard mt-4 BListings-tabs">
                        <TabsSection count={newEventTotalCount} />
                        <p className="text-right orange-text">
                            <a
                                href={`${VistPageLink}`}
                                target="_blank"
                                className="orange-text"
                            >
                                <Image src={Preview} className="mb-1"></Image>{" "}
                                <b>Visit Page</b>
                            </a>
                        </p>
                        <div
                            className=
                            {
                                endPath[4] !== "featured-listings"
                                    ? "manage-vou-main pt-3 pb-3 Blist"
                                    : "manage-feature pt-3 pb-3 Blist"
                            }
                        >
                            <div style={{ width: "59%" }}>
                                <p className="page-maintitle pt-2">{title}</p>

                                <p className="page-subtitle">
                                    Any events with published status will be visible in the
                                    marketplace
                                </p>
                            </div>


                            <div className="manage-vou">
                                <InputGroup className="search-bar">
                                    <InputGroup.Text>
                                        <MdSearch />
                                    </InputGroup.Text>
                                    <Form.Control
                                        className="search_feild"
                                        value={searchValue}
                                        onChange={(e) => handleSearchInput(e)}
                                        onKeyPress={handleKeypress}
                                    />
                                    <Button variant="outline-secondary" onClick={handleEventListing}>
                                        Search
                                    </Button>
                                </InputGroup>
                                <div
                                    variant="primary"
                                    className="create-btn export-btn-main"
                                    onClick={handleExport}
                                >
                                    Export <MdOutlineLogout className="export-btn" />
                                </div>
                            </div>

                        </div>

                        <SearchBarResults SearchValue={searchValue} />



                        <>
                            {isCheck.length != 0 ? (
                                <div className="d-flex">
                                    <Button
                                        className="green-btn width-140 p-0 mr-3"
                                        onClick={handleDelete}
                                    >
                                        Delete Selected
                                    </Button>
                                    <Form.Select
                                        aria-label="Default select example"
                                        className="table-select width-140 ml-3 status_select"
                                        onChange={handleChangeDropDownTop}
                                    >
                                        <option>Select Status</option>
                                        {TableRows.length != 0 ? (
                                            <>
                                                {TableRows[0]?.status_option.map((i) => {
                                                    return <option value={i.id}>{i.status} </option>;
                                                })}
                                            </>
                                        ) : (
                                            ""
                                        )}
                                    </Form.Select>
                                </div>
                            ) : (
                                ""
                            )}
                            {/* <span>Number of Business Listing : {TableRows.length}</span> */}
                            <div class="table-responsive-xl black-header">
                                <table class="recentact-table mt-3 table ver-middle manage-vou-table bus-list-Table">
                                    <thead>
                                        <tr>
                                            {/* <th className="radio-colors">
                                                <Form.Check
                                                    aria-label="option 1"
                                                    className="orange-checkbox"
                                                    onChange={handleSelectAll}
                                                    checked={isCheckAll}
                                                />
                                            </th> */}
                                            <th
                                                onClick={() => HandleSortCol("event_name")}
                                            >
                                                <Button className="btn btn-primary sortIcon">
                                                    Event Name
                                                    {flag.event_name === 0 ? (
                                                        <FaSort></FaSort>
                                                    ) : flag.event_name === 1 ? (
                                                        <FaSortUp></FaSortUp>
                                                    ) : (
                                                        <FaSortDown></FaSortDown>
                                                    )}
                                                </Button>
                                            </th>
                                            <th onClick={() => HandleSortCol("organization_name")}>
                                                <Button className="btn btn-primary sortIcon">
                                                    Organization{" "}
                                                    {flag.organization_name === 0 ? (
                                                        <FaSort></FaSort>
                                                    ) : flag.organization_name === 1 ? (
                                                        <FaSortUp></FaSortUp>
                                                    ) : (
                                                        <FaSortDown></FaSortDown>
                                                    )}
                                                </Button>
                                            </th>
                                            <th onClick={() => HandleSortCol("event_start_date")}>
                                                <Button className="btn btn-primary sortIcon">
                                                    Start Date
                                                    {flag.event_start_date === 0 ? (
                                                        <FaSort></FaSort>
                                                    ) : flag.event_start_date === 1 ? (
                                                        <FaSortUp></FaSortUp>
                                                    ) : (
                                                        <FaSortDown></FaSortDown>
                                                    )}
                                                </Button>
                                            </th>
                                            <th onClick={() => HandleSortCol("event_end_date")}> <Button className="btn btn-primary sortIcon">
                                                End Date
                                                {flag.event_end_date === 0 ? (
                                                    <FaSort></FaSort>
                                                ) : flag.event_end_date === 1 ? (
                                                    <FaSortUp></FaSortUp>
                                                ) : (
                                                    <FaSortDown></FaSortDown>
                                                )}
                                            </Button></th>
                                            <th onClick={() => HandleSortCol("event_location")}>
                                                <Button className="btn btn-primary sortIcon">
                                                    Location
                                                    {flag.event_location === 0 ? (
                                                        <FaSort></FaSort>
                                                    ) : flag.event_location === 1 ? (
                                                        <FaSortUp></FaSortUp>
                                                    ) : (
                                                        <FaSortDown></FaSortDown>
                                                    )}
                                                </Button>
                                            </th>
                                            <th onClick={() => HandleSortCol("event_status")}><Button className="btn btn-primary sortIcon">Status
                                                {flag.event_status === 0 ? (
                                                    <FaSort></FaSort>
                                                ) : flag.event_status === 1 ? (
                                                    <FaSortUp></FaSortUp>
                                                ) : (
                                                    <FaSortDown></FaSortDown>
                                                )}
                                            </Button>
                                            </th>


                                            <th className="action-min-main">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ShowTable == false ? (
                                            <>
                                                {TableRows.length > 0 ? (
                                                    TableRows?.map((item, key) => {
                                                        return (
                                                            <>
                                                                <tr>
                                                                    {/* <td className="radio-colors">
                                                                        <Form.Check
                                                                            aria-label="option 1"
                                                                            className="orange-checkbox"
                                                                            onChange={(e) => handleClick(e, key)}
                                                                            checked={isCheck.includes(
                                                                                item.business_info_id
                                                                            )}
                                                                        />
                                                                    </td> */}
                                                                    <td style={{ textAlign: "left", width: 300 }}
                                                                        title={item.event_name}>
                                                                        <Link
                                                                            className="vouname-blue"
                                                                            to={`/events-list/edit-event/${item.event_id}-${item.event_name}`}
                                                                        >
                                                                            {item.event_name.length > 40
                                                                                ? item.event_name.substring(0, 40) + "..."
                                                                                : item.event_name}
                                                                        </Link>

                                                                    </td>
                                                                    <td style={{ width: 300 }}
                                                                        title={item.organization_name}>
                                                                        {item.organization_name.length > 40
                                                                            ? item.organization_name.substring(0, 40) + "..."
                                                                            : item.organization_name}
                                                                    </td>
                                                                    <td>
                                                                        {formatDate(item.event_start_date)}
                                                                    </td>
                                                                    {/* cat */}
                                                                    <td>
                                                                        {formatDate(item.event_end_date)}
                                                                    </td>

                                                                    <td title={item.event_location}> {item.event_location.length > 40
                                                                        ? item.event_location.substring(0, 40) + "..."
                                                                        : item.event_location}</td>
                                                                    <td>
                                                                        <Form.Select
                                                                            aria-label="Default select example"
                                                                            className="table-select status_select"
                                                                            onChange={(e) =>
                                                                                handleChangeDropDown(e, key)
                                                                            }
                                                                        >
                                                                            {item.status_option.map((i) => {
                                                                                return (
                                                                                    <option
                                                                                        value={i.id}
                                                                                        selected={
                                                                                            item.event_status === i.id
                                                                                                ? "selected"
                                                                                                : ""
                                                                                        }
                                                                                    >
                                                                                        {i.status}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </Form.Select>
                                                                    </td>
                                                                    <td>
                                                                        <div className="action-min-img">
                                                                            <div
                                                                                alt="Email"
                                                                                onClick={(e) =>
                                                                                    handleRequestPopup(e, key)
                                                                                }
                                                                            >
                                                                                <Image
                                                                                    src={emailpic}
                                                                                    className="width-30"
                                                                                    title="Email"
                                                                                ></Image>

                                                                            </div>
                                                                            <div
                                                                                className="action-min-img"
                                                                                style={{ justifyContent: "center", gap: "10px" }}
                                                                            >
                                                                                <Link
                                                                                    to={`/events-list/edit-event/${item.event_id}-${item.event_name}`}
                                                                                >
                                                                                    <Image src={editpic} title="Edit"></Image>
                                                                                </Link>
                                                                                <div>
                                                                                    <Image
                                                                                        src={deletepic}
                                                                                        title="Delete"
                                                                                        width="18px"
                                                                                        onClick={(e) => handleDeleteEach(e, key)}
                                                                                    ></Image>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </td>
                                                                </tr>

                                                                {expandedRows == item.bu_id ? (
                                                                    <tr className="toggle-row">
                                                                        <td colSpan={9}>
                                                                            <Row className="dashboard-card BListingCards TableListing">
                                                                                <Col md="3">
                                                                                    <div className="card green-card">
                                                                                        <div className="dash-img-main">
                                                                                            <div className="dash-img">
                                                                                                <Image
                                                                                                    src={Dash5}
                                                                                                    height="22px"
                                                                                                ></Image>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="dash-content">
                                                                                            <p className="dash-text1 pt-4">
                                                                                                Total Vouchers
                                                                                            </p>
                                                                                            <p className="dash-text2">
                                                                                                {Nodata == true
                                                                                                    ? "0"
                                                                                                    : expandedRowsData.total_voucher}
                                                                                            </p>
                                                                                            <p className="text-right pb-3"></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md="3">
                                                                                    <div className="card green-card">
                                                                                        <div className="dash-img-main">
                                                                                            <div className="dash-img">
                                                                                                <Image
                                                                                                    src={Savings}
                                                                                                    height="20px"
                                                                                                ></Image>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="dash-content">
                                                                                            <p className="dash-text1 pt-4">
                                                                                                Life Time Sales
                                                                                            </p>
                                                                                            <p className="dash-text2">
                                                                                                $
                                                                                                {Nodata == true
                                                                                                    ? "0"
                                                                                                    : expandedRowsData.life_time_sale}
                                                                                            </p>
                                                                                            <p className="text-right pb-3"></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md="3">
                                                                                    <div className="card green-card">
                                                                                        <div className="dash-img-main">
                                                                                            <div className="dash-img">
                                                                                                <Image
                                                                                                    src={Dash3}
                                                                                                    height="24px"
                                                                                                ></Image>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="dash-content">
                                                                                            <p className="dash-text1 pt-4">
                                                                                                Year To Date Sales
                                                                                            </p>
                                                                                            <p className="dash-text2">
                                                                                                $
                                                                                                {Nodata == true
                                                                                                    ? "0"
                                                                                                    : expandedRowsData.year_todate_sales}
                                                                                            </p>
                                                                                            <p className="text-right pb-3"></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md="3">
                                                                                    <div className="card green-card">
                                                                                        <div className="dash-img-main">
                                                                                            <div className="dash-img">
                                                                                                <Image
                                                                                                    src={Dash4}
                                                                                                    height="22px"
                                                                                                ></Image>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="dash-content">
                                                                                            <p className="dash-text1 pt-4">
                                                                                                This Month Sales
                                                                                            </p>
                                                                                            <p className="dash-text2">
                                                                                                $
                                                                                                {Nodata == true
                                                                                                    ? "0"
                                                                                                    : expandedRowsData.this_month_sales}
                                                                                            </p>
                                                                                            <p className="text-right pb-3"></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Col>
                                                                            </Row>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </>
                                                        );
                                                    })
                                                ) : (
                                                    <tr class="toggle-row">
                                                        <td colspan={9}>
                                                            <p class="noData">{NoDataText.ErrText}</p>{" "}
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        ) : (
                                            <tr class="toggle-row">
                                                <td colspan={9}>
                                                    <p class="noData">{NoDataText.ErrText}</p>{" "}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {totalPageCount > 10 ? (
                                <Pagination
                                    totalPageCount={totalPageCount}
                                    setPageNumber={setPageNumber}
                                    limit={limit}
                                />
                            ) : (
                                <></>
                            )}
                        </>

                    </div>
                </div>
            </div>
            <PrivacyTermsConditions />
            {/* popups */}
            <Modal
                show={modalShow}
                onHide={() => {
                    setModalShow(false);
                }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="popup-modal w-600"
            >
                <Modal.Header className="requestCloseBtn" closeButton></Modal.Header>
                <Modal.Body className="mb-5 requestPopup">
                    <p
                        className="page-maintitle text-center"
                        style={{ color: "#E66100" }}
                    >
                        Send Request
                    </p>
                    <Row className="RequestPopDetails">
                        {/* <Col md="2"></Col> */}
                        <Col md="8" className="modelBodRequest">
                            <Form className="formmain mx-2 mt-4 signin-row profile-form pb-4 RequestForm">
                                <Row>
                                    <Col md="12" className="">
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="form-label-custom">
                                                Request Subject
                                                <span className="star-required"></span>
                                            </Form.Label>
                                            <InputGroup className="edit-border">
                                                <Form.Control
                                                    autoComplete="off"
                                                    type="text"
                                                    value={requestHandler.email_subject}
                                                    className="custom-formcontrol request_Missing_info not_Allowed_Click"
                                                    style={{
                                                        background: "#c4c4c4",
                                                        cursor: "not-allowed",
                                                        userSelect: "none",
                                                    }}
                                                    readOnly

                                                // onChange={(e) => setTriggerData(e.target.value)}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md="12" className="">
                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                            <Form.Label className="form-label-custom">
                                                Request Subject <span className="star-required">*</span>  <p className="info-text-space">
                                                    &#40;To start from a new line, please press Shift
                                                    + Enter.&#41;
                                                </p>
                                            </Form.Label>

                                            <FroalaEditorEvent
                                                TemplateContent={TemplateContent}
                                                setTemplateContent={setTemplateContent}
                                            />
                                            {/* <InputGroup className="edit-border">
                                               
                                                <Form.Control
                                                    autoComplete="off"
                                                    type="text"
                                                    value={"Request for missing information"}
                                                    className="custom-formcontrol"
                                                // onChange={(e) => setTriggerData(e.target.value)}
                                                />
                                            </InputGroup> */}
                                            {/* </OutsideClickHandler> */}
                                        </Form.Group>

                                    </Col>
                                </Row>
                                <div className="text-center d-flex">
                                    <Button
                                        variant="primary"
                                        type="submit"
                                        className="green-btn mt-3"
                                        onClick={(e) => SendRequest(e)}
                                    >
                                        Send
                                    </Button>
                                </div>
                            </Form>
                        </Col>
                        {/* <Col md="2"></Col> */}
                    </Row>
                </Modal.Body>
            </Modal>

        </>
    );
};

export default EventsListing;
